// Abu Dhabi - AC not cooling. Structured as a symptom -> cause table, unlike Dubai's checklist.
const content = {
    slug: 'ac-not-cooling',
    title: 'AC Not Cooling in Abu Dhabi? Match the Symptom to the Fix',
    description: (c) =>
        `AC not cooling in Abu Dhabi? Match your symptom to the likely cause and fix. Cleaning from ${c.money(c.tables.general[0].wall)}, diagnosis ${c.money(c.tables.repairDiagnosis)}.`,
    eyebrow: 'Abu Dhabi · AC not cooling',
    h1: 'AC Not Cooling in Abu Dhabi?',
    lead: 'Different symptoms point to different causes. Find yours below, try the quick checks, and book only the fix you need.',
    image: 'blog/living/aircon-evaporator.jpg',
    imageAlt: 'Inspecting an AC evaporator coil that is not cooling',
    facts: ['Symptom-by-symptom', 'Quick checks first', 'Book the right fix'],
    ctaLabel: 'See fixes and prices',
    priceTitle: 'Most common fix: a coil wash or cleaning',
    priceIntro: 'If the air is cool but weak, start here. For warm air, frost on pipes or a silent outdoor unit, book a diagnosis instead.',
    panel: { type: 'servicing', services: ['chemicalWash', 'general'], defaultMount: 'Wall' },
    sections: [
        {
            title: 'Match your symptom',
            cards: [
                { title: 'Cool but weak air', body: 'Dirty filter or coil. Wash the filter; if it doesn\'t help, book a coil wash.' },
                { title: 'Warm air, indoor fan running', body: 'The outdoor unit is not working - tripped breaker, failed capacitor or fan motor. Check the breaker, then book a diagnosis.' },
                { title: 'Frost on the pipes', body: 'Low refrigerant or a choked coil. Switch off to defrost and book a gas check.' },
                { title: 'Fine in the morning, losing by afternoon', body: 'Unit undersized for the room, dirty outdoor coil, or slightly low gas - common in inland villas.' },
                { title: 'One room warm, others fine (ducted)', body: 'A blocked branch duct, closed damper or dirty diffuser on that room.' },
                { title: 'Island apartment, no gas to refill', body: 'If you\'re on district cooling, check the filter and coil first, then ask building management about the chilled-water supply.' },
            ],
        },
        {
            title: 'Two checks anyone can do',
            tone: 'muted',
            steps: [
                { title: 'Feel the supply air', body: 'Hold your hand at the outlet after 15 minutes of running. Properly cold air with weak flow means a dirt problem; barely cool air with strong flow means a refrigerant or compressor problem.' },
                { title: 'Look at the outdoor unit', body: 'Is the fan spinning and is the coil clear of sand and stored items? A blocked outdoor unit can\'t get rid of heat.' },
            ],
        },
    ],
    faqs: [
        {
            question: 'Why does my AC stop cooling in the afternoon in Abu Dhabi?',
            answer: 'Inland afternoons push units to their limit. A dirty outdoor coil, slightly low gas or an undersized unit shows up first at peak heat.',
        },
        {
            question: 'What does it cost to fix an AC that is not cooling?',
            answer: (c) => `Cleaning costs ${c.money(c.tables.general[0].wall)} and a coil wash ${c.money(c.tables.chemicalWash[0].wall)} per split unit. A diagnosis visit costs ${c.money(c.tables.repairDiagnosis)}, and any repair is quoted before work starts.`,
        },
    ],
    schema: {
        name: 'AC Not Cooling - Fix in Abu Dhabi',
        serviceType: 'Air conditioner troubleshooting',
        offers: (c) => [
            { name: 'Coil chemical wash, 1 split unit', price: c.tables.chemicalWash[0].wall },
            { name: 'AC cleaning, 1 split unit', price: c.tables.general[0].wall },
            { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
        ],
    },
}

export default content
